import { Component } from 'react';

import { getLogger } from '../../services/logger';

import type { ErrorInfo, ReactNode } from 'react';

import styles from './ErrorBoundary.module.scss';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

const logger = getLogger('ErrorBoundary');

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    logger.error('Unhandled render error', {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
    });
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className={styles.container}>
          <h1 className={styles.heading}>Something went wrong</h1>
          <p className={styles.subtitle}>
            The application encountered an unexpected error. Your recent changes
            may not have been saved.
          </p>
          <button
            type="button"
            className={styles.button}
            onClick={this.handleReload}
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
